import gql from "graphql-tag";
import { client } from "../../index";

export default async ({ odeId, userId, role, odeIntersectionId }) => {
  await client.mutate({
    variables: {odeId, userId, role, odeIntersectionId},
    mutation: gql`
      mutation(
        $odeId: ID!,
        $userId: ID!,
        $role: String!,
        $odeIntersectionId: ID!) {
        updateODE(
          where: {
            id: $odeId
          },
          data: {
            network: {
              update: { # Update specific User
                where: { id: $userId }
                data: {
                  odes : {
                    update: {
                      where: { id: $odeIntersectionId },
                      data: {
                        rol: $role
                      }
                    }
                  }
                }
              }
            }
          }
        ){
          id
        }
      }
    `
  });
};
